import { Button, FormControl, TextField, Typography } from "@mui/material";
import { useState } from "react";

interface IProps {
  handleNext: (email: string) => void;
  email: string;
}

const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const EnterEmail = ({ handleNext, email: initialEmail }: IProps) => {
  const [email, setEmail] = useState(initialEmail);
  const [error, setError] = useState<string | null>(null);
  const [touched, setTouched] = useState(false);

  const validateEmail = (value: string) => {
    if (!value) {
      return "Email is required";
    }
    if (!isValidEmail(value)) {
      return "Please enter a valid email address";
    }
    return null;
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (touched) {
      setError(validateEmail(newEmail));
    }
  };

  const handleBlur = () => {
    setTouched(true);
    setError(validateEmail(email));
  };

  const handleSubmit = () => {
    setTouched(true);
    const validationError = validateEmail(email);
    if (!validationError) {
      handleNext(email);
    } else {
      setError(validationError);
    }
  };

  return (
    <div style={{ paddingRight: 16, marginTop: 20 }}>
      <FormControl component="fieldset" sx={{ width: "100%" }}>
        <TextField
          label="Email"
          value={email}
          onChange={handleEmailChange}
          onBlur={handleBlur}
          variant="outlined"
          sx={{ width: "100%" }}
          required
          error={!!error}
          helperText={error}
          type="email"
          autoComplete="email"
          inputProps={{
            "aria-label": "Email address",
            "data-testid": "email-input",
            onKeyDown: (e: React.KeyboardEvent) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            },
          }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          We will send a receipt to your email.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mb: 2 }}
          onClick={handleSubmit}
          disabled={!!error || !email}
        >
          Continue
        </Button>
      </FormControl>
    </div>
  );
};
